// V3 Assisting Blocks
// 
// This module registers all assisting blocks for V3.
// It first loads V2 blocks (which internally loads V1) for backward compatibility.
// No V3-specific assisting blocks are needed at this time.

import AssistingBlocksV2 from "../../v2/assistingBlocks";

const AssistingBlocksV3 = function(props) {
    // Register all V2 assisting blocks first (which chains to V1)
    // This ensures old saved scripts can still find 'rest_params', 'rest_params_v2', etc.
    AssistingBlocksV2(props);
    
    return null;
};

export default AssistingBlocksV3;
